import { CanadaOperationCost } from '../operation-cost'

export const OntarioOperationCost = {
  ...CanadaOperationCost,
} as const
